import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import AudioPlayer from '../AuthUI/AudioPlayer';
import ReactDOM from 'react-dom';
import ReactMarkdown from 'react-markdown';
// import style from './markdown-styles.module.css';
import style from './markdown-styles-copy.module.css';
// import { WebSocketContext } from '../../contexts/WebSocketContext';
import IconButton from '@mui/material/IconButton';
import { Avatar, Grow } from '@mui/material';
import mosaicGuardians from '../../image/mosaicGuardians.png';
import {CircularProgress} from '@mui/material';
import OpenIconSpeedDial from '../chat/OpenIconSpeedDial';
import AlertDialogSlide from '../AlertDialogSlide';
import { useInView } from 'react-intersection-observer';
import { Box, fontSize } from '@mui/system';
import { Buffer } from 'buffer';
import DialogSlide from './DialogSlide';


const MarkdownComponent = forwardRef(({ openai, fetch_image, audio, id, message, setMessages, currentUser }, ref) => {
  const audioRefs = useRef([]);
  // const { fetch_image, fetch_title } = React.useContext(WebSocketContext);
  const [currentIndex, setCurrentIndex] = useState(-1); // Przechowuj indeks aktualnie odtwarzanego audio
  const lastIndex = useRef(0);
  const role = message.role
  const markdown = message?.content? message.content[0]?.text?.value: ''
  const [state, setState] = useState({});
  const [imageUrl, setImageUrl] = useState(null);
  const [ dialogOpen, setDialogOpen ] = useState(false);
  
  const [ player, setPlayer ] = useState({
    isPlayed: false
  })

  const handleFetchImage = async (text) => {
    if (!text) return
    if(!imageUrl){
      console.log('handleFetchImage', imageUrl, fetch_image)
      const url = await fetch_image(text);
      if (!url) return
      setImageUrl(url);
      setDialogOpen(true); 
    }else{
      setDialogOpen(true);
    }
    
  }

    const fetchSpeech = async (text, key) => {
      if (player.isPlayed){
        audioRefs.current[key].pause();
        setPlayer(prev => ({...prev, isPlayed: false}))
        audioRefs.current[key].currentTime = 0;
        return
      }
      if (!audioRefs.current[key].src){
        setPlayer(prev => ({...prev, isPlayed: true}))
        console.log('fetchSpeech', text)
        const mp3 = await openai.audio.speech.create({
          model: "tts-1",
          voice: "alloy",
          input: text,
        }).catch(err => {
          console.log(err)
        });
        const audio = audioRefs.current[key];
        const buffer = Buffer.from(await mp3.arrayBuffer());
        console.log('audio is generated')
        audio.src = URL.createObjectURL(new Blob([buffer], { type: 'audio/mpeg' }));
        audio.play();
        audioRefs.current[key] = audio;
      }else{
        const audio = audioRefs.current[key];
        audio.play();
      }
    }

    const dialogDelete = async () => {
      console.log('dialogDelete message')
      setState({
        title: 'Delete Message',
        description: 'Are you sure you want to delete this message?',
        additional_description: null,
        open: true,
        text_field: false,
        thread: null,
        confirm: fetchDelete,
      })
    }

    const fetchDelete = async () => {
      setState({});
      setMessages(prevMessages => prevMessages.filter(item => item.id !== message.id))
      await openai.beta.threads.messages.del(
        message.thread_id,
        message.id
      );
      console.log('delete', message.id)
    }

    useImperativeHandle(ref, () => ({
      get_id: () => id,
      stop: (index) => {
        if (index != id){
          for (let i = 0; i < audioRefs.current.length; i++) {
            if (audioRefs.current[i]){
              audioRefs.current[i].pause();
            }
          }
        }
      },
    }));

    const togglePlayPause = (index) => {
      // Zatrzymaj wszystkie instancje audio
      audioRefs.current.forEach((audioInstance, i) => {
          if (audioInstance) {
              if (i === index) {
                // console.log('audioInstance', audioInstance.paused)
                  if (audioInstance.paused) {
                      audioInstance.currentTime = 0
                      try {
                        audioInstance.play()
                        .then(() => setCurrentIndex(index))
                        .catch((error) => console.error('Błąd przy odtwarzaniu:', error));

                      } catch (error) {
                        console.error(error);
                        setCurrentIndex(-1); // Zresetuj indeks na pauzowanie
                      }
                       // Odtwarzaj aktualne audio
                      
                  } else {
                      audioInstance.pause(); // Pauzuj aktualne audio
                      setCurrentIndex(-1); // Zresetuj indeks na pauzowanie
                  }
              } else {
                  audioInstance.pause(); // Pauzuj inne audio
              }
          }
      });
  };

  // useEffect(() => {
  //   try {
  //     const audioElement = listAudio[0]; // Odtwarzanie pierwszego audio
  //       if (audioElement && audioElement.paused) {
  //         audioElement.play()
  //           .then(() => console.log('Odtwarzanie rozpoczęte'))
  //           .catch((error) => console.error('Błąd przy odtwarzaniu:', error));
  //       }
  //   } catch (error) {
  //     console.error(error);
  //   }

  // }, [listAudio]);    
 
  const CustomParagraph = ({ children, index, audio, nextIndex }) => {
    const isLastIndex = index === nextIndex.current[nextIndex.current.length - 1];

    return (
      
        <p style={{ position: 'relative', margin: '0', transition: 'height 0.3s ease' }}>
              {/* <AudioPlayer 
                  audioRefs={audioRefs}
                  audio={audio}
                  index={index} 
                  isPlaying={currentIndex === index}
                  setListAudio={setListAudio}
                  togglePlayPause={togglePlayPause} 
              /> */}
              {children}
          </p>

          
        );
      };

    const Testowy = React.memo(({ markdown, audio, role, final=true }) => {

      const nextIndex = useRef(0);
      return (
        // <GrowOnView>
        <ReactMarkdown
          className={style.reactMarkDown}
          style = {{  }}
          components={{
            p: (props) => {
              const index = nextIndex.current++;
              if (index > lastIndex.current.length - 1){
                lastIndex.current++;
                return (
                  
                    <CustomParagraph
                      {...props}
                      index={index}
                      audio={audio}
                      nextIndex={nextIndex}
                    />
                  
                );
              } else if(final){
                return (
                  
                  <CustomParagraph
                    {...props}
                    index={index}
                    audio={audio}
                    nextIndex={nextIndex}
                  />
                
                );
              }
            },
            hr: (props) => {
              return
            },
          }}
        >
          {/* <AlertDialogSlide /> */}
          {markdown}
        </ReactMarkdown>
        // </GrowOnView>
      );
    
    });
      useEffect(() => {
        
      }, [] )

      return (
        <div style={{ 
          // backgroundColor: 'rgb(107 107 107 / 75%)',
          // borderRadius: '10px',
          // color: 'black',
          // border: 'solid 1px',
          // padding:  '3px',
          // background: 'linear-gradient(34deg, rgb(116 116 116 / 82%) 0%, rgb(227 227 227 / 70%) 100%)'
          }}>
            <DialogSlide image={imageUrl} open={dialogOpen} setOpen={setDialogOpen} />
            <audio
              ref={ (el) => (audioRefs.current[message.id] = el) }
              onEnded={ () => setPlayer(prev => ({...prev, isPlayed: false})) }
              onPlay={ () => setPlayer(prev => ({...prev, isPlayed: true})) }
              onStop={ () => setPlayer(prev => ({...prev, isPlayed: false})) }
            />
          {/* <ChildComponent onButtonClick={handleButtonClick} count={count} /> */}
          <OpenIconSpeedDial play={player.isPlayed} fetch_image={handleFetchImage} fetchSpeech={fetchSpeech} fetchDelete={dialogDelete} message={message} role={role} currentUser={currentUser} />
          {/* <Avatar
            sizes="small"
            alt={currentUser?.nick_name}
            src={ role === 'assistant'?mosaicGuardians:"/static/images/avatar/7.jpg"}
            sx={{ width: 40, height: 40}}
          /> */}
          <Testowy markdown={markdown} audio={audio} />
          <AlertDialogSlide state={state}/>
        </div>
      );
    });
  

export default MarkdownComponent;